import { Button } from "@/components/ui/button";
import { Download, LogOut } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export function TopBar() {
  const { toast } = useToast();

  const handleDownloadReport = () => {
    toast({
      title: "Your Money Report is Coming! 📊",
      description: "We're crunching the numbers — get ready to see where you can save more!",
    });
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    toast({
      title: "See You Soon! 👋",
      description: "Don't forget to upload those receipts when you're back!",
    });
  };

  return (
    <header className="hidden md:flex h-16 border-b border-border bg-card px-6 items-center justify-between sticky top-0 z-40">
      <div>
        <h2 className="text-lg font-semibold text-foreground">Dashboard</h2>
        <p className="text-sm text-muted-foreground">Let's find every dollar you can save 💰</p>
      </div>

      <div className="flex items-center gap-4">
        <Button onClick={handleDownloadReport} className="bg-primary hover:bg-primary/90">
          <Download className="w-4 h-4 mr-2" />
          Download Report
        </Button>
        <Button onClick={handleLogout} variant="outline">
          <LogOut className="w-4 h-4 mr-2" />
          Logout
        </Button>
      </div>
    </header>
  );
}
